import React from "react";
import styles from "./learningStartCourse.module.scss";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useStartCourse } from "../../hooks/useStartCourse";
import { useAppContext } from "@kunduz/feature-website-context";
import { getContentUrl, ReservedWords } from "@kunduz/utility-common";
import { AUTH_PAGEURLS } from "@kunduz/utility-common";

export const LearningStartCourse = (props: Props) => {
  const { t } = useTranslation("kunduzcom_learning");
  const { description, canUserStartCourse, title, id, type } = props;
  const router = useRouter();
  const { student, kunduzApiToken } = useAppContext();
  const { getConsumableContent } = useStartCourse(kunduzApiToken);

  const startCourse = async () => {
    try {
      const { detailed_url } = await getConsumableContent(type, id);

      const url = getContentUrl({
        lang: props.lang,
        contentType: ReservedWords.TR_CONTENT_MATERIAL,
        segments: [],
      });

      if (detailed_url) router.push(url + detailed_url.substring(1));
    } catch {
      return;
    }
  };

  const handleStartCourseClicked = () => {
    if (!student.data) {
      router.push(AUTH_PAGEURLS.B2C_SELECT_LOGIN_METHOD);

      return;
    }

    startCourse();
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      {canUserStartCourse && (
        <button onClick={handleStartCourseClicked} className={styles.button}>
          {t("learning_start_course_cta_label")}
        </button>
      )}
    </div>
  );
};

interface Props {
  title: string;
  description: string;
  canUserStartCourse: boolean;
  type: string;
  id: number;
  lang: "tr" | "en";
}
